var R = /* @__PURE__ */ ((N) => (N[N.EMAIL_LOGIN = 0] = "EMAIL_LOGIN", N[N.SELECT_WALLET = 1] = "SELECT_WALLET", N[N.RONIN_WALLET_LOGIN = 2] = "RONIN_WALLET_LOGIN", N[N.SIGN_UP = 3] = "SIGN_UP", N))(R || {});
const C = 60, r = 4;
export {
  r as ACCOUNT_TAG_PADDING,
  R as LOGIN_SLIDE_STATE,
  C as RONIN_QRCODE_REFRESH
};
//# sourceMappingURL=login.js.map
